import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import {
  RecurrenceEditor,
  RecurrenceEditorAllModule,
} from '@syncfusion/ej2-angular-schedule';

@Component({
  selector: 'app-calendar-recurrence-editor',
  templateUrl: './recurrence-editor.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, RecurrenceEditorAllModule, DropDownListModule],
})
export class RecurrenceEditorComponent implements AfterViewInit {
  @Input() params: any;
  @ViewChild('reccurenceComponent')
  public reccurenceComponent: RecurrenceEditor;
  public value = 'FREQ=DAILY;INTERVAL=1';
  public datas: Record<string, string>[] = [
    { rule: 'FREQ=DAILY;INTERVAL=1' },
    { rule: 'FREQ=DAILY;INTERVAL=2;UNTIL=20410606T000000Z' },
    { rule: 'FREQ=DAILY;INTERVAL=2;COUNT=8' },
    {
      rule: 'FREQ=WEEKLY;BYDAY=MO,TU,WE,TH,FR;INTERVAL=1;UNTIL=20410729T000000Z',
    },
    {
      rule: 'FREQ=MONTHLY;BYDAY=FR;BYSETPOS=2;INTERVAL=1;UNTIL=20410729T000000Z',
    },
    { rule: 'FREQ=MONTHLY;BYDAY=FR;BYSETPOS=2;INTERVAL=1' },
    { rule: 'FREQ=YEARLY;BYDAY=MO;BYSETPOS=-1;INTERVAL=1;COUNT=5' },
  ];
  public fields: Record<string, any> = { text: 'rule', value: 'rule' };
  public index = 0;

  public onChange({ value }): void {
    this.reccurenceComponent.setRecurrenceRule(value);
  }

  get values() {
    return this.reccurenceComponent.value;
  }

  ngAfterViewInit(): void {
    this.reccurenceComponent.setRecurrenceRule(this.value);
  }

  set(value: string) {
    this.value = value;
  }
}
